import { lazy, Suspense, useState } from "react";
import { useI18n } from "@/lib/i18n";

const ChatWidget = lazy(() => import("./ChatWidget"));

const LABEL: Record<string, string> = {
  tr: "Asistanla konuş",
  en: "Chat with assistant",
  de: "Mit Assistent chatten",
  es: "Chatear con asistente",
  ru: "Чат с ассистентом",
  fr: "Discuter avec l'assistant",
};

// Kulaklıklı sohbet ikonu — yuvarlak konuşma balonu + üstte kulaklık bandı + yan kulaklıklar + 3 nokta
function HeadsetChatIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden fill="none">
      {/* Kulaklık bandı (arka) */}
      <path
        d="M10 24a14 14 0 0 1 28 0"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />
      {/* Konuşma balonu (yuvarlak) */}
      <circle cx="24" cy="26" r="11" fill="currentColor" opacity="0.18" />
      <circle cx="24" cy="26" r="11" stroke="currentColor" strokeWidth="2" fill="none" />
      {/* Balonun kuyruğu */}
      <path
        d="M18 35.5l-2.5 4.5 5.5-2.2"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      {/* Sol kulaklık */}
      <rect x="7" y="22" width="6" height="9" rx="2.5" fill="currentColor" />
      {/* Sağ kulaklık */}
      <rect x="35" y="22" width="6" height="9" rx="2.5" fill="currentColor" />
      {/* 3 nokta (yazıyor) */}
      <circle cx="19" cy="26" r="1.6" fill="currentColor" />
      <circle cx="24" cy="26" r="1.6" fill="currentColor" />
      <circle cx="29" cy="26" r="1.6" fill="currentColor" />
    </svg>
  );
}

export default function ChatLauncher() {
  const { locale } = useI18n();
  const [open, setOpen] = useState(false);
  const label = LABEL[locale] || LABEL.en;

  return (
    <>
      {!open && (
        <button
          onClick={() => setOpen(true)}
          aria-label={label}
          className="fixed bottom-5 right-5 z-50 h-14 w-14 rounded-full flex items-center justify-center transition-base hover:scale-105 border-2"
          style={{
            background: "radial-gradient(circle at 50% 50%, hsl(0 0% 8%) 0%, hsl(0 0% 6%) 100%)",
            borderColor: "hsl(348 72% 45%)",
            boxShadow: "0 8px 22px -8px hsl(0 0% 0% / 0.6)",
            color: "hsl(348 70% 60%)",
          }}
        >
          <HeadsetChatIcon className="relative h-[52px] w-[52px]" />
          {/* Online noktası — renk değiştiren */}
          <span
            className="absolute bottom-0.5 right-0.5 h-3 w-3 rounded-full animate-color-pulse"
            style={{ boxShadow: "0 0 0 2px hsl(0 0% 6%)" }}
            aria-hidden
          />
        </button>
      )}
      {open && (
        <Suspense fallback={null}>
          <ChatWidget onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </>
  );
}
